export default "__VITE_ASSET__cd15fcf9__"